import type { IPasswordSettingsResources } from "@/src/settings/PasswordSettings.Resources";

export const PasswordSettingsResourcesEn: IPasswordSettingsResources = {
    oldPasswordText: "Current password",
    newPasswordText: "New password",
    currentPasswordText: "Current password",
    confirmPasswordText: "Repeat new password",
    confirmButton: "Save",
    saveChangesMessage: "Changes have been saved.",
    title: "Change your password",
    description: "Set new password for your account",
    successTitle: "Password has been changed",
    successButton: "Return to goodie",
    passwordRequiredError: "Password is required",
    passwordInvalidSizeError: "Password should have at least 6 digits",
    newPasswordIsTheSameAsOldOne: "New password must be different than old one",
    passwordsInvalidError: "Both passwords should match. Enter again",
    passwordsNotMatchError: "Passwords don't match",
};
